//  Forms
export {FORM_SECOND_STEP} from '../../constants';
export const FORM_LOGIN = 'formLogin'

// Sign Up
export const F_GUEST_EMAIL = 'guestEmail'

// Sign In
export const F_LOGIN_EMAIL = 'loginEmail'

// 10 Percent Discount
export const F_DISCOUNT_AGREEMENT = 'discountAgreement'
export const F_DISCOUNT_PASSWORD = 'discountPassword'

// Personal Info
export const F_TITLE = 'title'
export const F_FIRST_NAME = 'firstName'
export const F_LAST_NAME = 'lastName'
export const F_MOBILE = 'mobile'
export const F_MOBILE_COUNTRY = 'mobileCountry'
export const F_NATIONALITY = 'nationality'
export const F_COUNTRY = 'country'
export const F_ADDRESS = 'address'
export const F_CITY = 'city'
export const F_REGION = 'region'
export const F_ZIP_CODE = 'zipCode'
export const F_TRIP_REASON = 'tripReason'
export const F_ARRIVAL_TIME = 'arrivalTime'

// Payment Details
export const F_PROMO_CODE = 'promoCode'
export const F_PAYMENT_METHOD = 'paymentMethod'
export const F_CARD_TYPE = 'cardType'
export const F_CARD_HOLDER = 'cardHolderName'
export const F_CARD_NUMBER = 'cardNumber'
export const F_CARD_EXPIRES = 'cardExpires'
export const F_CARD_CVV = 'cardCVV'

export const PAYMENT_CARD = 'card'
export const PAYMENT_PAYPAL = 'paypal'

// Confirm the Reservation
export const F_SEND_EMAILS = 'sendEmails'

export const F_BOOKING_URL = 'bookingUrl'


// Actions
export const SAVE_PROMO_CODE_INIT = 'SECOND_STEP_ACTION.SAVE_PROMO_CODE_INIT'
export const SAVE_PROMO_CODE_SUCCESS = 'SECOND_STEP_ACTION.SAVE_PROMO_CODE_SUCCESS'
export const SAVE_PROMO_CODE_FAILED = 'SECOND_STEP_ACTION.SAVE_PROMO_CODE_FAILED'
export const DELETE_PROMO_CODE_INIT = 'SECOND_STEP_ACTION.DELETE_PROMO_CODE_INIT'
export const DELETE_PROMO_CODE_SUCCESS = 'SECOND_STEP_ACTION.DELETE_PROMO_CODE_SUCCESS'
export const DELETE_PROMO_CODE_FAILED = 'SECOND_STEP_ACTION.DELETE_PROMO_CODE_FAILED'

export const CONFIRM_BOOKING_INIT = 'SECOND_STEP_ACTION.CONFIRM_BOOKING_INIT'
export const CONFIRM_BOOKING_SUCCESS = 'SECOND_STEP_ACTION.CONFIRM_BOOKING_SUCCESS'
export const CONFIRM_BOOKING_FAILED = 'SECOND_STEP_ACTION.CONFIRM_BOOKING_FAILED'

export const MESSAGE_BOX_TOGGLE = 'SECOND_STEP_ACTION.MESSAGE_BOX_TOGGLE'

export const FIELDS_PERSONAL_INFO = [
  F_GUEST_EMAIL,
  F_TITLE,
  F_FIRST_NAME,
  F_LAST_NAME,
  F_MOBILE,
  F_NATIONALITY,
  F_COUNTRY,
  F_ADDRESS,
  F_CITY,
  F_REGION,
  F_ZIP_CODE,
  F_TRIP_REASON,
]

export const FIELDS_PAYMENT_CARD = [
  F_CARD_TYPE,
  F_CARD_HOLDER,
  F_CARD_NUMBER,
  F_CARD_EXPIRES,
  F_CARD_CVV,
]
